import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";
import * as wConsts from "../consts/website-consts";
import NotFound from "../components/notfound";
class Page404 extends Component {

  componentDidMount() {
    //this.props.pageHandler('home');
    this.props.dispatch({ type: wConsts.ACTION_SET_PAGETYPE, payload: "404" });
  }

  render() {
    //console.log("ccontent", this.props.Content)
    return (
      <NotFound/>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    Content: state.Website.Page.Content
  };
}

export default connect(mapStateToProps)(Page404);
